
export const searchJobs = async (query, location, filters = {}, apiKey) => {
    if (!apiKey) {
        throw new Error("RapidAPI Key is missing. Please add it in Settings.");
    }

    const options = {
        method: 'GET',
        headers: {
            'X-RapidAPI-Key': apiKey,
            'X-RapidAPI-Host': 'jsearch.p.rapidapi.com'
        }
    };

    // Construct query string
    // Query format for JSearch: "developer in Texas, USA"
    const fullQuery = `${query} in ${location}`.trim();

    // Basic query params
    const params = new URLSearchParams({
        query: fullQuery,
        page: '1',
        num_pages: '1',
        ...filters // date_posted, remote_jobs_only, etc.
    });

    try {
        const response = await fetch(`https://jsearch.p.rapidapi.com/search?${params.toString()}`, options);

        if (!response.ok) {
            const err = await response.json();
            throw new Error(err.message || `Job Search Failed: ${response.status}`);
        }

        const data = await response.json();
        return data.data; // JSearch returns { status: "OK", data: [...] }
    } catch (error) {
        console.error("Job Search Error:", error);
        throw error;
    }
};
